import Swal from "sweetalert2";
import apiMarim from "../../../services/service_undefined_v2";
import moment from "moment";
import pen from "../../../assets/pen.png";
import search from "../../../assets/search.png";

export default {
  components: {
    pen,
    search
  },
  data() {
    return {
      hostshift: "",
      listEgg: [],
      saleEgg: [],
      sales: {}, // ← เก็บยอดขายตาม id
      now_date: moment(new Date()),
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      hasSaved: false, // ก่อนบันทึกจะแสดง "รอบันทึก"
    };
  },
  created() {
    this.checkUser();
    if (sessionStorage.hostshift) {
      this.hostshift = JSON.parse(sessionStorage.hostshift);
    } else {
      this.$router.push("/");
    }
  },
  computed: {},
  methods: {
    statusBadgeClass(b) {
      if (!this.hasSaved) return "badge bg-secondary";
      switch (b.statusType) {
        case "equal":
          return "badge bg-success";
        case "less":
          return "badge bg-danger";
        case "more":
          return "badge bg-warning text-dark";
        default:
          return "badge bg-secondary";
      }
    },
    handleSave () {
      // console.log('test');
      const expectedMap = this.saleEgg.reduce((acc, x) => {
        acc[x.item_id] = Number(x.amount) || 0;
        return acc;
      }, {});

      // อัปเดตสถานะให้กับ listEgg ทีละแถว
      this.listEgg = this.listEgg.map((b) => {
        const expected = Number((expectedMap[b.id] !== undefined ? expectedMap[b.id] : 0));
        const input = Number((this.sales && this.sales[String(b.id)] !== undefined) ? this.sales[String(b.id)] : 0);
      
        let status = "ตรง";
        let statusType = "equal";
        if (input === expected) {
          status = "ตรง";
          statusType = "equal";
        } else if (input < expected) {
          status = "ขาด";
          statusType = "less";
        } else {
          status = "เกิน";
          statusType = "more";
        }
      
        return Object.assign({}, b, {
          status: status,       // ข้อความที่จะโชว์
          statusType: statusType // ใช้ตัดสินใจสี
        });
      });

      this.hasSaved = true;
      // this.$store.commit('Loading')
      const items = this.listEgg.map((b) => {
        const expected = Number((expectedMap[b.id] !== undefined ? expectedMap[b.id] : 0));
        const amount = Number((this.sales && this.sales[String(b.id)] !== undefined) ? this.sales[String(b.id)] : 0);
        return {
          date: moment(this.now_date).format("YYYY-MM-DD"),
          item_id: b.id,
          amount: amount,
          status: b.statusType, // "equal" | "less" | "more"
          expected: expected
        };
      });

      const payload = { ...items };

      this.$store.commit("Loading");
      apiMarim.saveConfirmSaleEgg(
        {
          items 
        },
        this.header,
        results => {
          if (results.data.status) {
            this.$notification["success"]({
              message: "บันทึกข้อมูลสำเร็จ",
              description: "บันทึกข้อมูลสำเร็จ"
            });
          
          } else {
            this.$notification["warning"]({
              message: "บันทึกข้อมูลไม่สำเร็จ",
              description: "บันทึกข้อมูลไม่สำเร็จ"
            });
          }
          this.$store.commit("Loading");
        },
        errors => {
          console.log(errors);
          this.$notification["warning"]({
            message: "บันทึกข้อมูลไม่สำเร็จ",
            description: "บันทึกข้อมูลไม่สำเร็จ"
          });
          this.$store.commit("Loading");
        }
      );

    },
    onFocus(id) {
      if (this.sales[id] === 0) {
        this.sales[id] = "";
      }
    },
    onBlur(id) {
      if (this.sales[id] === "" || this.sales[id] === null) {
        this.sales[id] = 0;
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    getProductEgg() {
      this.$store.commit("Loading");
      apiMarim.getProductEgg(
        this.header,
        results => {
          console.log(results);
          if (results.data.status) {
            this.listEgg = results.data.data;
            this.listEgg.forEach(b => {
              if (!(b.id in this.sales)) {
                this.$set(this.sales, b.id, 0);
              }
            });
            console.log(results.data.data);
          } else {
            this.isDisabled = true;
            this.$notification["warning"]({
              message: "ไม่สามารถดึงข้อมูลได้",
              description: "ไม่สามารถดึงข้อมูลได้"
            });
          }
          this.$store.commit("Loading");
        },
        errors => {
          console.log(errors);
          this.isDisabled = true;
          this.$notification["warning"]({
            message: "ไม่สามารถดึงข้อมูลได้",
            description: "ไม่สามารถดึงข้อมูลได้"
          });
          this.$store.commit("Loading");
        }
      );
    },
    getProductEggSummarySale() {
      this.$store.commit("Loading");
      apiMarim.getProductEggSummarySale(
        {
          date : moment(this.now_date).format("YYYY-MM-DD")
        },
        this.header,
        results => {
          if (results.data.status) {
            this.saleEgg = results.data.data;
          } else {
            this.$notification["warning"]({
              message: "ไม่สามารถดึงข้อมูลได้",
              description: "ไม่สามารถดึงข้อมูลได้"
            });
          }
          this.$store.commit("Loading");
        },
        errors => {
          console.log(errors);
          this.$notification["warning"]({
            message: "ไม่สามารถดึงข้อมูลได้",
            description: "ไม่สามารถดึงข้อมูลได้"
          });
          this.$store.commit("Loading");
        }
      );
    }
  },
  mounted() {
    this.getProductEgg();
    this.getProductEggSummarySale();
    $("#ToolModalSaleEgg").on("show.bs.modal", function() {}.bind(this));
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/pos/confirm_sale_egg.js